import { useCallback, useRef, useState } from 'react';
import TopStrip from './components/TopStrip';
import SiteHeader from './components/SiteHeader';
import Hero from './components/Hero';
import FeedSection from './components/FeedSection';
import DownloadZone from './components/DownloadZone';
import TagWall from './components/TagWall';
import CollectionZone from './components/CollectionZone';
import NetdiskNav from './components/NetdiskNav';
import CommentZone from './components/CommentZone';
import SiteFooter from './components/SiteFooter';
import Toast from './components/Toast';

export default function Home() {
  const [toast, setToast] = useState<string | null>(null);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const notify = useCallback((msg: string) => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setToast(msg);
    timerRef.current = setTimeout(() => setToast(null), 2200);
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <TopStrip />
      <SiteHeader notify={notify} />
      <main>
        <Hero notify={notify} />
        <FeedSection notify={notify} />
        <DownloadZone notify={notify} />
        <TagWall notify={notify} />
        <CollectionZone notify={notify} />

        <section className="border-b border-background-200 bg-primary-950">
          <div className="mx-auto flex w-full max-w-[1240px] flex-col items-start gap-6 px-4 py-10 md:flex-row md:items-center md:justify-between md:px-8 md:py-12">
            <div>
              <p className="flex items-center gap-2 text-xs text-accent-300">
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-robot-2-line"></i>
                </span>
                找不到想要的资源？
              </p>
              <h3 className="mt-2 font-heading text-2xl font-black text-background-50 md:text-3xl">
                把需求丢进话题墙，帮你补齐资源包
              </h3>
              <p className="mt-2 max-w-xl text-sm text-background-200">
                提交后进入待补清单，聚合站会按热度排期整理，并同步更新到爆瓜福利下载入口与网盘文件专区。
              </p>
            </div>
            <div className="flex w-full flex-col gap-3 sm:flex-row md:w-auto">
              <button
                type="button"
                onClick={() => notify('已提交资源需求到话题墙')}
                className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-medium text-foreground-950 transition-colors hover:bg-accent-400"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-send-plane-line"></i>
                </span>
                提交资源需求
              </button>
              <button
                type="button"
                onClick={() => notify('正在打开完整网盘文件专区')}
                className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-6 py-3 text-sm text-background-100 transition-colors hover:border-accent-400 hover:text-accent-300"
              >
                浏览网盘文件专区
              </button>
            </div>
          </div>
        </section>

        <NetdiskNav notify={notify} />
        <CommentZone notify={notify} />
      </main>
      <SiteFooter notify={notify} />
      <Toast message={toast} />
    </div>
  );
}